import HttpClient from '@/common/boot/HttpClient'

////////////////////////////////////////////////
const salvarUsuario = async ({ commit }, payload) => {

  commit('BUSCANDO', true);

  return await HttpClient.post('/app/grupo-rotas', payload).then(response => {
    commit('INSERIR_USUARIO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

//////////////////////////////////////////////////////////
const recuperarUsuario = ({ commit, state }, payload) => {

  const usuario = state.items.filter(usuario => usuario.id === payload.id)

  if(usuario.length) {
    commit('INSERIR_USUARIO_SELECIONADO', ...usuario)
    return true
  }

  return false
}

////////////////////////////////////////////////////
const atualizarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.put(`/app/grupo-rotas/${payload.id}`, payload).then(response => {
    commit('ATUALIZAR_USUARIO', payload)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

////////////////////////////////////////////////////
const deletarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.delete(`/app/grupo-rotas/${payload.id}`).then(response => {
    commit('DELETAR_USUARIO', payload)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })

}

const listarGrupos = async ({commit}) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/app/rotas`).then(response => {
    commit('INSERIR_LISTA_GRUPOS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarGrupoComRotas = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/app/grupo-rotas/${payload}/associar-rotas`, payload).then(response => {
    commit('INSERIR_USUARIO_SELECIONADO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const associarRotaAoGrupo = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/app/grupo-rotas/${payload.grupoId}/associar-rotas`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

export {
  salvarUsuario,
  recuperarUsuario,
  atualizarUsuario,
  deletarUsuario,
  listarGrupos,
  recuperarGrupoComRotas,
  associarRotaAoGrupo
}